import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Button } from "../../components/ui/button";
import { LogOut, Inbox, FileText } from "lucide-react";
import { BRAND } from "../../lib/site-data";

export default function AdminLayout() {
    const { user, logout, loading } = useAuth();
    const navigate = useNavigate();

    if (loading)
        return (
            <div className="min-h-screen bg-[#050505] flex items-center justify-center text-zinc-400">
                Yükleniyor...
            </div>
        );

    if (!user || user === false) {
        navigate("/admin/login", { replace: true });
        return null;
    }

    return (
        <div className="min-h-screen bg-[#050505] text-white flex">
            <aside className="w-64 border-r border-white/5 bg-[#070707] hidden md:flex flex-col">
                <div className="px-6 py-6 border-b border-white/5">
                    <Link to="/" className="block">
                        <p className="font-display text-base text-white">{BRAND.name}</p>
                        <p className="text-[10px] uppercase tracking-[0.25em] text-cyan-300/80 mt-1">
                            Admin Panel
                        </p>
                    </Link>
                </div>
                <nav className="px-3 py-5 space-y-1 flex-1">
                    <NavLink
                        to="/admin/leads"
                        className={({ isActive }) =>
                            `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${
                                isActive ? "bg-cyan-400/10 text-cyan-300" : "text-zinc-300 hover:bg-white/5"
                            }`
                        }
                        data-testid="admin-nav-leads"
                    >
                        <Inbox className="h-4 w-4" />
                        Lead Talepleri
                    </NavLink>
                    <NavLink
                        to="/admin/blog"
                        className={({ isActive }) =>
                            `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${
                                isActive ? "bg-cyan-400/10 text-cyan-300" : "text-zinc-300 hover:bg-white/5"
                            }`
                        }
                        data-testid="admin-nav-blog"
                    >
                        <FileText className="h-4 w-4" />
                        Blog Yazıları
                    </NavLink>
                </nav>
                <div className="p-4 border-t border-white/5">
                    <p className="text-xs text-zinc-500 mb-3 truncate">{user.email}</p>
                    <Button
                        variant="outline"
                        size="sm"
                        onClick={async () => {
                            await logout();
                            navigate("/admin/login");
                        }}
                        className="w-full bg-transparent border-white/10 text-white hover:bg-white/5"
                        data-testid="admin-logout"
                    >
                        <LogOut className="h-4 w-4 mr-2" />
                        Çıkış
                    </Button>
                </div>
            </aside>
            <div className="flex-1 min-w-0">
                <header className="md:hidden border-b border-white/5 px-5 py-3 flex items-center justify-between">
                    <Link to="/" className="font-display text-sm text-white">
                        Admin Panel
                    </Link>
                    <div className="flex gap-2">
                        <Link to="/admin/leads" className="text-xs text-zinc-300">
                            Leads
                        </Link>
                        <Link to="/admin/blog" className="text-xs text-zinc-300">
                            Blog
                        </Link>
                        <button
                            onClick={async () => {
                                await logout();
                                navigate("/admin/login");
                            }}
                            className="text-xs text-zinc-400"
                        >
                            Çıkış
                        </button>
                    </div>
                </header>
                <Outlet />
            </div>
        </div>
    );
}
